module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Function</th>\r\n        <th>\r\n            Level of Impairment\r\n            <a id="level-of-impairment-info" tabindex="0" role="button" data-toggle="popover"\r\n               data-trigger="focus" title="Level of Impairment Info" data-container="body"\r\n               data-content="\r\n                    <div align=\'left\'>\r\n                    <b>Score 0</b> - performs or can perform all essential components of the activity,\r\n                    with or without an assistive device, such that:\r\n                    <ul>\r\n                    <li> No significant impairment of functions remains</li>\r\n                    <li> Activity is not required by the client</li>\r\n                    <li> Client may benefit from but does not require verbal or physical assistance </li>\r\n                    </ul>\r\n\r\n                    <b>Score 1</b> - performs or can perform most essential components of the activity,\r\n                    with or without an assistive device, but some impairment of the function remains such\r\n                    that client requires some verbal or physical assistance in some or all components of the activity.\r\n                    This includes clients who:\r\n                    <ul>\r\n                    <li>Experience minor, intermittent fatigue in performing the activity or</li>\r\n                    <li>Take longer that would be required for an unimpaired person</li>\r\n                    <li>Require some verbal prompting to complete the task</li>\r\n                    </ul>\r\n\r\n                    <b>Score 2</b> - can not perform most of the essential components of the activity,\r\n                    even with assistive device, and /or requires a great deal of verbal or physical assistance\r\n                    to accomplish the activity. This includes clients who:\r\n                    <ul>\r\n                    <li>Experience frequent fatigue or minor exertion in performing the activity</li>\r\n                    <li>Take an excessive amount of time to perform the activity</li>\r\n                    <li>Must perform the activity much more frequently then an unimpaired person</li>\r\n                    <li>Requires frequent verbal prompting to complete the task</li>\r\n                    </ul>\r\n\r\n                    <b>Score 3</b> - can not perform the activity and requires someone else to perform the task,\r\n                    although applicant may be able to assist in small ways; or requires constant physical assistance\r\n                    </div>\r\n                ">\r\n                <span class="glyphicon glyphicon-question-sign"></span>\r\n            </a>\r\n        </th>\r\n        <th>\r\n            Unmet Need for Care\r\n            <a id="unmet-need-for-care-info" tabindex="0" role="button" data-toggle="popover"\r\n               data-trigger="focus" title="Unmet Need for Care Info" data-container="body"\r\n               data-content="\r\n                    <div align=\'left\'>\r\n                    <b>Score 0</b> - the applicant\'s need for assistance is met to the extent that the applicant is at no risk\r\n                    to health or safety if additional assistance is not acquired; or the applicant has no need for assistance;\r\n                    or additional assistance will not benefit the applicant;\r\n                    <br/>\r\n                    <br/>\r\n\r\n                    <b>Score 1</b> - This applicant\'s need for assistance is met most of the time, or there is minimal\r\n                    risk to the health and safety of the applicant if additional assistance is not acquired\r\n                    <br/>\r\n                    <br/>\r\n\r\n                    <b>Score 2</b> - This applicant\'s need for assistance is not met most of the time, or there is moderate\r\n                    risk to the health and safety of the applicant if additional assistance is not acquired\r\n                    <br/>\r\n                    <br/>\r\n\r\n                    <b>Score 3</b> - This applicant\'s need for assistance is seldom or never met, or there is severe\r\n                    risk to the health and safety of the applicant that would require acute medical intervention if\r\n                    assistance is not acquired\r\n                    </div>\r\n                ">\r\n                <span class="glyphicon glyphicon-question-sign"></span>\r\n            </a>\r\n        </th>\r\n        <th>Comments</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
 _.each(rows, function(row, index){ 
__p+='\r\n    <tr id="'+
((__t=( index ))==null?'':__t)+
'">\r\n        <td>'+
((__t=( "" + (index + 1) + ". " + row.function ))==null?'':__t)+
'</td>\r\n        <td>\r\n            ';
 if (row.editable) { 
__p+='\r\n            <div class="btn-group loi">\r\n                <a class="btn btn-primary btn-sm ';
 if (row.levelOfImpairment == 0) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="0">Score 0</a>\r\n                <a class="btn btn-primary btn-sm ';
 if (row.levelOfImpairment == 1) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="1">1</a>\r\n                <a class="btn btn-primary btn-sm ';
 if (row.levelOfImpairment == 2) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="2">2</a>\r\n                <a class="btn btn-primary btn-sm ';
 if (row.levelOfImpairment == 3) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="3">3</a>\r\n            </div>\r\n            ';
 } 
__p+='\r\n            ';
 if (!row.editable) { 
__p+='\r\n                <div id="levelOfImpairment-'+
((__t=( index ))==null?'':__t)+
'">'+
((__t=( calculateSum('levelOfImpairment', row.start, row.stop, rows) ))==null?'':__t)+
'</div>\r\n            ';
 } 
__p+='\r\n        </td>\r\n        <td>\r\n            ';
 if (row.editable) { 
__p+='\r\n            <div class="btn-group unfc">\r\n                <a class="btn btn-primary btn-sm ';
 if (row.unmetNeedForCare == 0) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="0">Score 0</a>\r\n                <a class="btn btn-primary btn-sm ';
 if (row.unmetNeedForCare == 1) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="1">1</a>\r\n                <a class="btn btn-primary btn-sm ';
 if (row.unmetNeedForCare == 2) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="2">2</a>\r\n                <a class="btn btn-primary btn-sm ';
 if (row.unmetNeedForCare == 3) { 
__p+=' active ';
 } else { 
__p+=' notActive ';
 } 
__p+='" data-title="3">3</a>\r\n            </div>\r\n            ';
 } 
__p+='\r\n            ';
 if (!row.editable) { 
__p+='\r\n                <div id="unmetNeedForCare-'+
((__t=( index ))==null?'':__t)+
'">'+
((__t=( calculateSum('unmetNeedForCare', row.start, row.stop, rows) ))==null?'':__t)+
'</div>\r\n            ';
 } 
__p+='\r\n        </td>\r\n        <td>\r\n            <textarea class="form-control donr-comment" rows="1">'+
((__t=( row.comment ))==null?'':_.escape(__t))+
'</textarea>\r\n        </td>\r\n    </tr>\r\n    ';
 }) 
__p+='\r\n    <tr>\r\n        <td></td>\r\n        <td></td>\r\n        <td></td>\r\n    </tr>\r\n\r\n    </tbody>\r\n</table>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/med-forms/determination-of-need-revised-view.html
// module id = 371
// module chunks = 0